module.exports = __webpack_public_path__ + "static/media/watch-fitness.a1786017.svg";